import { IconButton, Tooltip, useBreakpointValue } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  ATTRIBUTE_TAG_DATA,
  type LearnerFeedbackAttributeTag,
} from '@/client/services/learnerFeedback/constants'

import { TooltipButton } from '@/components/UI/TooltipButton'

export interface AttributeTagButtonProps {
  tag: LearnerFeedbackAttributeTag
  isSelected: boolean
  disabledData?: {
    disabled: boolean
    tooltip?: string
  }
  onToggle: () => void
  variant?: 'icon' | 'icon-text'
}

export default function AttributeTagButton({
  tag,
  isSelected,
  disabledData,
  onToggle,
  variant = 'icon',
}: AttributeTagButtonProps) {
  const isMobile = useBreakpointValue({ base: true, md: false })
  const tagData = ATTRIBUTE_TAG_DATA[tag]

  return variant === 'icon-text' ? (
    <TooltipButton
      aria-label={tagData.label}
      isDisabled={disabledData?.disabled}
      tooltipContent={disabledData?.tooltip}
      onClick={onToggle}
      borderRadius="9999px"
      cursor="pointer"
      height="32px"
      minWidth="auto"
      padding="4px 12px"
      whiteSpace="nowrap"
      bg="bg"
      fontSize="14px"
      lineHeight="1"
      color={isSelected ? tagData.color : 'fg.muted'}
      borderWidth="1px"
      borderStyle="solid"
      borderColor={isSelected ? tagData.color : 'border.emphasized'}
      _hover={{
        '@media(hover: hover)': {
          bg: 'bg.muted',
          borderColor: tagData.color,
          color: tagData.color,
        },
      }}
      _active={{
        bg: 'bg.muted',
        color: tagData.color,
        transform: 'scale(0.98)',
      }}
      variant="ghost"
    >
      <FontAwesomeIcon icon={tagData.icon} style={{ marginRight: '8px' }} />
      {tagData.label}
    </TooltipButton>
  ) : (
    <Tooltip
      label={tagData.label}
      placement="top"
      closeDelay={isMobile === true ? 1000 : 0}
      closeOnClick
      hasArrow
    >
      <IconButton
        aria-label={tagData.label}
        isDisabled={disabledData?.disabled}
        icon={<FontAwesomeIcon icon={tagData.icon} size="lg" />}
        borderRadius="full"
        cursor="pointer"
        width="36px"
        height="36px"
        minWidth="36px"
        padding="0px"
        bg="bg"
        _hover={{
          '@media(hover: hover)': {
            bg: 'bg.muted',
            color: tagData.color,
          },
        }}
        _active={{
          bg: 'bg.muted',
          color: tagData.color,
          transform: 'scale(0.95)',
        }}
        color={isSelected ? tagData.color : 'fg.muted'}
        onClick={onToggle}
      />
    </Tooltip>
  )
}
